import { Box, Column, Row, Txt } from "@stenajs-webui/core";

import type { TravelledVehicle } from "../../common/graphql/fragments/gql/TravelledVehicle";
import type { VehicleType } from "../../common/graphql/fragments/gql/VehicleType";
import { Information } from "../../common/texts";
import VehicleTypeIcon from "../../common/vehicle-types/VehicleTypeIcon";

interface TravelledVehicleResultProps {
  travelledVehicleResult: TravelledVehicle;
  vehicleType: VehicleType;
}

export const TravelledVehicleResult = ({
  travelledVehicleResult: { vehicleRegNo, vehicleTypeCode, length, height },
  vehicleType: { description },
}: TravelledVehicleResultProps) => (
  <Box gap={2} spacing>
    <Txt>{`${vehicleRegNo} ${Information.VehicleShippedBeforeSuffix}`}</Txt>
    <Row gap={2}>
      <Column>
        <VehicleTypeIcon type={vehicleTypeCode} />
      </Column>
      <Column gap>
        <TravelledVehicleField label={"Vehicle type"} text={description} />
        <Row gap={2}>
          {length > 0 && (
            <TravelledVehicleField label={"Length"} text={length + "m"} />
          )}
          {height > 0 && (
            <TravelledVehicleField label={"Height"} text={height + "m"} />
          )}
        </Row>
      </Column>
    </Row>
  </Box>
);

interface TravelledVehicleFieldProps {
  label: string;
  text: string;
}

const TravelledVehicleField = ({ label, text }: TravelledVehicleFieldProps) => (
  <Column>
    <Txt size={"small"}>{label}</Txt>
    <Txt>{text}</Txt>
  </Column>
);
